// extracted by mini-css-extract-plugin
export var acitonButtons = "_10-0";
export var additionalIcon = "_10-f";
export var block = "_10-1";
export var blockContent = "_10-7";
export var blockDescription = "_10-8";
export var blockIcon = "_10-9";
export var blockTitle = "_10-6";
export var border = "_10-a";
export var center = "_10-l";
export var edge = "_10-b";
export var edgeLabel = "_10-c";
export var edgePath = "_10-d";
export var error = "_10-e";
export var flowchart = "_10-g";
export var flowchartContent = "_10-h";
export var highlighted = "_10-3";
export var hover = "_10-4";
export var icon = "_10-i";
export var left = "_10-m";
export var navButton = "_10-j";
export var navButtons = "_10-k";
export var right = "_10-n";
export var selected = "_10-2";
export var small = "_10-5";